var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueBgMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blue-bg-master",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1921.131,
    height: 1082.545,
    viewBox: "0 0 1921.131 1082.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25543",
    "data-name": "Path 25543",
    d: "M0,0H832.131V1082.545H0Z",
    transform: "translate(0 -1.12)",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 1920,
    height: 1080,
    transform: "translate(0 1.12)",
    fill: "#0087ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ovals",
    transform: "translate(403 281.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(961)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(72 27)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(982 130)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(0 157)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangles",
    transform: "translate(547.172 594.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    width: 13,
    height: 13,
    rx: 2,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 3.365)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    opacity: 0.478,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HeaderBacker",
    transform: "translate(1089 1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_46",
    "data-name": "Mask Group 46",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M3100.939,1095l-370.3,1081.3,541.078-.418L3270.99,1095Z",
    transform: "translate(-2439.819 -1095.283)",
    fill: "#fff",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M3359.366,1095h-36.908L2540.8,2173.885l819.327,2.685Z",
    transform: "translate(-2528.225 -1095.553)",
    fill: "#fff",
    opacity: 0.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBgMaster);
export default __webpack_public_path__ + "static/media/blue-bg-master.41573981642a1e97d6897cfae2e03880.svg";
export { ForwardRef as ReactComponent };